module.exports = __webpack_public_path__ + "img/del.8747499a.png";